module.exports = __webpack_public_path__ + "static/img/empty-project.e0b6ae19.svg";